import * as React from 'react';
import * as styles from './styles.css';
import { Image, UIHeading3 } from '@cian/ui-kit';
import stars from '../../assets/Stars.svg';
import { AiModalSkeleton } from './Skeleton';
import { randomSummaryTextList, useTypewriterPhrases } from '../../../AiSummaryModalShared/utils';

export interface IAiSummaryLoadingBodyProps {
  onComplete?: () => void;
}

export const AiSummaryLoadingBody = ({ onComplete }: IAiSummaryLoadingBodyProps): React.JSX.Element => {
  const { announcedPhrase, phase, typedText } = useTypewriterPhrases(randomSummaryTextList);
  const hasCompletedRef = React.useRef(false);

  React.useEffect(() => {
    if (phase === 'completed' && !hasCompletedRef.current) {
      hasCompletedRef.current = true;
      onComplete?.();
    }
  }, [onComplete, phase]);

  return (
    <div className={styles['container']}>
      <div className={styles['head-container']}>
        <div className={styles['head-stub']} />
        <div className={styles['head-stub']} />
        <div className={styles['head-stub']} />
        <div className={styles['head-stub']} />
        <div className={styles['head-stub']} />
      </div>
      <div className={styles['body-container']}>
        <div className={styles['body-stubs-container']}>
          <div>
            <div className={styles['first-stub']} />
            <div className={styles['second-stub']} />
          </div>
          <div className={styles['third-stub']} />
        </div>
        <div className={styles['rotate-text-container']}>
          <Image height={24} src={stars} width={24} />
          <div
            aria-hidden="true"
            className={`${styles['phrase']} ${phase === 'exiting' ? styles['phrase-exiting'] : ''}`}
            data-phase={phase}
            data-testid="ai-summary-loading-phrase"
          >
            <div className={styles['phrase-text']}>
              <UIHeading3 color="text-secondary-default">{typedText}</UIHeading3>
            </div>
          </div>
          <span aria-atomic="true" aria-live="polite" className={styles['visually-hidden']}>
            {announcedPhrase}
          </span>
        </div>
        <AiModalSkeleton />
      </div>
    </div>
  );
};
